<div *ngIf="isIE" id="navbar" class="sticky" >
  <span style="color: beige; text-align:center"><b>For better performance please use Firefox,Chrome or Edge</b></span>
</div> 
<div class="container fluidtypo">
  <div class="row">
    <img src="assets/img/FDNY-Cadet-Logo.png" alt="FDNY Cadet Logo"  style="margin-left: 15px;">
  </div>
  <div class="redborder">
  </div>
  <!-- Router Outlet -->
  <router-outlet>
  </router-outlet>
  <!-- -->
  <div class="footer">
    <p>&copy; {{currentYear}} Fire Department City of New York</p>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/app.component.html